import { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { Banner } from '@thermon-platforms/thermon-ui-core';
import api from 'util/api';


function Upload({path, onUpload=()=>{}}) {
  const [file, setFile] = useState();
  const [error, setError] = useState();
  const [processing, setProcesing] = useState(false);
  const [showBanner, setShowBanner] = useState(false);

  function handleChange(event) {
    setFile(event.target.files[0]);
  }

  function handleUpload() {
    const formData = new FormData();
    formData.append('File', file, file.name);
    setProcesing(true);
    api(path, {
      method: 'POST',
      body: formData,
      headers: {
        // This is an awkward hack to remove the Content-Type
        // header which let's the browser select the correct
        // type for upload. Unfortunately, just setting it to
        // multipart/form-data; doesn't work
      }
    })
      .then(() => {
        setShowBanner(true);
        setFile(undefined);
        onUpload();
      })
      .catch(async res => {
        setError(await res.text());
      })
      .finally(() => {
        setProcesing(false);
      });
  }

  return (
    <div className="image-upload-container">
      <Banner small={true} status="ok" show={showBanner}>
        <Trans>Upload was successful!</Trans>
      </Banner>
      <Banner small={true} status="alert" show={error}>
        {error}
      </Banner>
      {file ?
        <iframe
          src={URL.createObjectURL(file)}
          width="100%"
          height="480"
           allow="fullscreen"
        ></iframe>
      : null}
      <ul className="form">
        <li>
          <label htmlFor="image-upload">
            <Trans>Select a PDF to upload</Trans>
          </label>
          <input
            type="file"
            id="image-upload"
            accept="application/pdf"
            onChange={handleChange}
          />
          <button
            className={`primary ${processing ? 'processing' : ''}`}
            disabled={processing || !file}
            onClick={handleUpload}
          >
            <Trans>Save File</Trans>
          </button>
        </li>
      </ul>
    </div>
  )
}

export default Upload;
